import { Pipe, PipeTransform } from '@angular/core';
import { Moment } from 'moment';
import { DateHelper } from '../helpers/date-helper';

@Pipe({ name: 'displayDate' })
export class DisplayDatePipe implements PipeTransform {
  constructor() {}

  transform(date: Moment | string, includeTime: boolean): string {
    return DateHelper.format(date, includeTime);
  }
}
